import { render, staticRenderFns } from "./ConfirmCustomerDetail.vue?vue&type=template&id=335a646f&scoped=true&"
import script from "./ConfirmCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./ConfirmCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a646f",
  null
  
)

export default component.exports